webpackJsonp([34],{

/***/ 368:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(680)
}
var Component = __webpack_require__(50)(
  /* script */
  __webpack_require__(529),
  /* template */
  __webpack_require__(765),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 404:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.04b8d3c.png";

/***/ }),

/***/ 529:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    token: {
      type: String
    },
    type: {
      type: String
    },
    send: {
      type: String
    }
  },
  data: function data() {
    return {
      loading: true,
      dataSent: false,
      formTextarea: ''
    };
  },

  computed: {
    logoProviderFeedback: function logoProviderFeedback() {
      return this.$store.getters.logoProviderFeedback;
    },
    defaultMessageHeader: function defaultMessageHeader() {
      return this.type.toLowerCase().trim() === 'sindico' ? 'A Administradora não divulgará a oferta aos condôminos.' : 'Os condôminos não serão notificados.';
    },
    defaultMessageBody: function defaultMessageBody() {
      return this.type.toLowerCase().trim() === 'sindico' ? 'Por favor, para melhoria dos nossos serviços gostaríamos que informasse o motivo.' : 'Caso queira comentar o motivo, agradecemos.';
    }
  },
  mounted: function mounted() {
    var _this = this;

    var data = {
      token: this.token,
      type: this.type,
      send: this.send
    };
    this.$store.dispatch('getAllInfoFeedback', data).then(function (response) {
      _this.loading = false;
    }).catch(function (err) {
      return console.log(err);
    });
    if (this.send === 'false') {
      this.$store.dispatch('sendEmailToCondominiums', data).then(function (response) {
        _this.loading = false;
      }).catch(function (err) {
        return console.log(err);
      });
    }
  },

  methods: {
    sendFormData: function sendFormData() {
      var _this2 = this;

      // REVIEW: transição não ta sendo feita =/
      // this.dataSent = !this.dataSent
      // return
      // BUG: ta falso fixo, arrumar na API
      this.$store.commit('updateSatisfaction', false);
      this.$store.commit('updateObservation', this.formTextarea);

      this.$store.dispatch('sendHotsiteFeedback', this.token).then(function (_ref) {
        var data = _ref.data;

        _this2.dataSent = true;
      }).catch(function (err) {
        return console.log(err);
      });
    }
  }
});

/***/ }),

/***/ 633:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(360)(true);
// imports


// module
exports.push([module.i, ".application .theme--light.card,.theme--light .card{background-color:#fff;color:rgba(67,95,199,.87);margin-top:5%}.logo-header{position:relative;width:100%;text-align:center;padding:20px;min-height:145.63px;background-color:#fff}.administrator,.logo-header img{max-width:200px;max-height:100px}.titulo-logo{width:300px;margin:auto}.titulo-logo h4{width:calc(100% - 80px);color:#a2a2a2;float:left;position:relative;top:11px;font-size:39px;left:2px}.titulo-logo img{width:80px;height:80px;float:left}.progrees-line{position:absolute;bottom:0;margin:0;left:0}", "", {"version":3,"sources":["C:/ias/Projects/Athos/CondoPlaza/condoplaza-frontend/Condoplaza.Vue/src/components/feedback/feedback.vue"],"names":[],"mappings":"AACA,oDACI,sBAAuB,AACvB,0BAA+B,AAC/B,aAAe,CAClB,AACD,aACI,kBAAmB,AACnB,WAAY,AACZ,kBAAmB,AACnB,aAAc,AACd,oBAAqB,AACrB,qBAAuB,CAC1B,AACD,gCACE,gBAAiB,AACjB,gBAAkB,CACnB,AACD,aACE,YAAa,AACb,WAAa,CACd,AACD,gBACE,wBAAyB,AACzB,cAAe,AACf,WAAY,AACZ,kBAAmB,AACnB,SAAU,AACV,eAAgB,AAChB,QAAU,CACX,AACD,iBACE,WAAY,AACZ,YAAa,AACb,UAAY,CACb,AACD,eACE,kBAAmB,AACnB,SAAS,AACT,SAAU,AACV,MAAQ,CACT","file":"feedback.vue","sourcesContent":["\n.theme--light .card, .application .theme--light.card{\n    background-color: #fff;\n    color: rgba(67, 95, 199, 0.87);\n    margin-top: 5%;\n}\n.logo-header{\n    position: relative;\n    width: 100%;\n    text-align: center;\n    padding: 20px;\n    min-height: 145.63px;\n    background-color: #fff;\n}\n.logo-header img, .administrator{\n  max-width: 200px;\n  max-height: 100px;\n}\n.titulo-logo{\n  width: 300px;\n  margin: auto;\n}\n.titulo-logo h4 {\n  width: calc(100% - 80px);\n  color: #a2a2a2;\n  float: left;\n  position: relative;\n  top: 11px;\n  font-size: 39px;\n  left: 2px;\n}\n.titulo-logo img {\n  width: 80px;\n  height: 80px;\n  float: left;\n}\n.progrees-line{\n  position: absolute;\n  bottom:0;\n  margin: 0;\n  left: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 680:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(633);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(361)("15565768", content, true, {});

/***/ }),

/***/ 765:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "background-color": "#f3f3f3",
      "height": "100%",
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "logo-header"
  }, [(_vm.logoProviderFeedback === '') ? _c('v-slide-x-transition', {
    staticClass: "hotsite-body",
    attrs: {
      "mode": "out-in"
    }
  }, [_c('div', {
    staticClass: "titulo-logo mb-4 float-l"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    attrs: {
      "src": __webpack_require__(404),
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_vm._v("CondoPlaza")])])]) : _c('v-slide-x-transition', {
    staticClass: "hotsite-body",
    attrs: {
      "mode": "out-in"
    }
  }, [_c('img', {
    key: _vm.logoProviderFeedback,
    attrs: {
      "src": _vm.logoProviderFeedback,
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-progress-linear', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "progrees-line",
    attrs: {
      "indeterminate": true,
      "height": "2",
      "color": "red",
      "background-color": "white"
    }
  })], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-md": "",
      "text-xs-center": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": "",
      "offset-xs1": ""
    }
  }, [_c('h4', {
    staticStyle: {
      "color": "gray"
    }
  }, [_vm._v("\n        Fique tranquilo!\n      ")]), _vm._v(" "), _c('h6', {
    staticStyle: {
      "color": "gray"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.defaultMessageHeader) + "\n      ")])]), _vm._v(" "), (!_vm.dataSent) ? _c('v-slide-y-reverse-transition', {
    attrs: {
      "mode": "out-in"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": "",
      "offset-xs1": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-1"
  }, [_c('v-card-text', [_c('p', [_vm._v("\n               " + _vm._s(_vm.defaultMessageBody) + "\n             ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "multi-line": "",
      "label": "Comente aqui..."
    },
    model: {
      value: (_vm.formTextarea),
      callback: function($$v) {
        _vm.formTextarea = $$v
      },
      expression: "formTextarea"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "block": "",
      "color": "success"
    },
    on: {
      "click": _vm.sendFormData
    }
  }, [_vm._v("Gravar")])], 1)], 1)], 1)], 1) : _c('v-slide-y-reverse-transition', {
    attrs: {
      "mode": "out-in"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": "",
      "offset-xs1": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-1"
  }, [_c('v-card-text', [_c('h5', [_vm._v("\n                 Muito Obrigado 😄\n             ")])])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/34.ce53f77c60c66e1cdf52.js